import i from './register-password.container';

export default i;
